import React, { createRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ToolBarAction from './toolbar-action';

const TopBarMessageEditor = ({
  submitMethod,
  addAttachmentMethod,
  addDraftMethod,
  close,
  draftTime
}) => {
  const [displayExpandedToolbar, setDisplayExpandedToolbar] = useState(true);
  const MIN_TOOLBAR_WIDTH_PX = 1200;
  const toolbarRef = createRef();
  const { t } = useTranslation();

  useEffect(() => {
    const toolbarElement = toolbarRef.current;
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.contentRect.width < MIN_TOOLBAR_WIDTH_PX) {
          setDisplayExpandedToolbar(false);
        } else {
          setDisplayExpandedToolbar(true);
        }
      }
    });

    if (toolbarElement) {
      resizeObserver.observe(toolbarElement);
    }

    return () => {
      if (toolbarElement) {
        resizeObserver.unobserve(toolbarElement);
      }
    };
  }, []);

  return (
    <div className="px-2 py-2 bd-highlight d-flex justify-content-between w-100" ref={toolbarRef}>
      <div className="d-flex align-items-center">
        <div className="">
          <ToolBarAction
            onClick={() => null}
            icon="lf-icon-reply"
            title={t("message-toolbar.reply")}
            disabled={true}
            hideText={!displayExpandedToolbar}
          />
        </div>
        <div className="">
          <ToolBarAction
            onClick={() => null}
            icon="lf-icon-reply-all"
            title={t("message-toolbar.reply-all")}
            disabled={true}
            hideText={!displayExpandedToolbar}
          />
        </div>
        <div className="">
          <ToolBarAction
            onClick={() => null}
            icon="lf-icon-send"
            title={t("message-toolbar.resend")}
            disabled={true}
            hideText={!displayExpandedToolbar}
          />
        </div>
        <div className="">
          <ToolBarAction
            onClick={() => null}
            icon="lf-icon-mail-open"
            title={t("message-toolbar.read-unread")}
            disabled={true}
            hideText={!displayExpandedToolbar}
          />
        </div>
        <div className="">
          <ToolBarAction
            onClick={() => null}
            icon="lf-icon-folder"
            title={t("message-toolbar.move-to")}
            disabled={true}
            hideText={!displayExpandedToolbar}
          />
        </div>
        <div className="">
          <ToolBarAction
            onClick={() => null}
            icon="lf-icon-print"
            title={t("message-toolbar.print")}
            disabled={true}
            hideText={!displayExpandedToolbar}
          />
        </div>
        <div className="">
          <ToolBarAction
            onClick={() => null}
            icon="lf-icon-trash"
            title={t("message-toolbar.move-to-trash")}
            disabled={true}
            hideText={!displayExpandedToolbar}
          />
        </div>
      </div>
      <div className="d-flex align-items-center">
        {draftTime &&
          <div className="draft-saved">
            <div>
              {t("messageEditor.draft-saved")}
              {' '}{draftTime}
            </div>
          </div> }
        <div className="px-1">
          <ToolBarAction
            className="btn-toolbar-action-compose"
            onClick={addAttachmentMethod}
            icon="lf-icon-add"
            title={t("messageEditor.attach")}
            hideText={!displayExpandedToolbar}
          />
        </div>
        <div className="px-1">
          <ToolBarAction
            className="btn-toolbar-action-compose"
            color="secondary"
            onClick={addDraftMethod}
            title={t("messageEditor.save-draft")}
            allowTextHidden={false}
          />
        </div>
        <div className="px-1">
          <ToolBarAction
            className="btn-toolbar-action-compose"
            color="secondary"
            onClick={close}
            title={t("messageEditor.discard")}
            allowTextHidden={false}
          />
        </div>
        <div className="px-1">
          <ToolBarAction
            className="btn-toolbar-action-compose"
            color="primary"
            onClick={submitMethod}
            title={t("messageEditor.send")}
            allowTextHidden={false}
          />
        </div>
      </div>
    </div>
  );
};

export default TopBarMessageEditor;
